import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HomePage } from '../home/home';
import { EnquiriesPage } from '../enquiries/enquiries';
import { TransactionsPage } from '../transactions/transactions';
import { AgentPage } from '../agent/agent';
import { BanksPage } from '../banks/banks';
import {CardTransactionsPage} from "../card-transactions/card-transactions";
import { UssdTransactionsPage } from '../ussd-transactions/ussd-transactions';

/**
 * Generated class for the TabsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {

  tabOneRoot: any;
  tabTwoRoot: any;
  tabThreeRoot: any;
  tabFourRoot: any;
  tabFiveRoot: any;

  constructor() {

    this.tabOneRoot = HomePage;
    this.tabTwoRoot = EnquiriesPage;
    this.tabThreeRoot = TransactionsPage;
    this.tabFourRoot = UssdTransactionsPage;
    this.tabFiveRoot = CardTransactionsPage;
    //this.tabFiveRoot = BanksPage;
    //CardTransactionsPage
  }

  

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts